<nz-drawer [nzVisible]="visible" nzPlacement="right" nzTitle="Notifications" (nzOnClose)="close()"
    [nzMaskClosable]="false" nzWrapClassName="notificationDrawer" [nzFooter]="footer">
    <ng-container *nzDrawerContent>
        <nz-skeleton *ngIf="isDataLoading" [nzParagraph]="{ rows: 30}" [nzActive]="true"></nz-skeleton>
        <div *ngIf="!isDataLoading">
            <div *ngIf="announcements.length">
                <div *ngFor="let data of announcements" class="d-flex announcements-box">
                    <div>                        
                        <p class="cursor" (click)="isVisibleModal = true;modalTitle=data.title;currentDescription=data.description"><u>{{data.title}}</u></p>
                        <p class="break-word">{{data.desc.length > 80 ? data.desc.slice(0,80) + '...' : data.desc}}</p>                       
                    </div>
                    <div class="cursor" (click)="removeFromList(data.id)">X</div>
                </div>                
            </div>
            <div *ngIf="announcements.length == 0">
                <p>No Notifications Found</p>
            </div>
        </div>
    </ng-container>
    <ng-template #footer>
        <button nz-button nzType="primary" *ngIf="announcements.length > 0" style="color:white;border-color:white"
        (click)="clearAllAnnouncements()">Clear All</button>
    </ng-template>
</nz-drawer>

<nz-modal [nzBodyStyle]="{ overflow: 'auto' }" [nzMaskClosable]="false" [nzWidth]="850" nzCentered
  [nzVisible]="isVisibleModal" [nzTitle]="modalTitle" [nzFooter]="footerTpl" (nzOnCancel)="isVisibleModal=false">
  <ng-container *nzModalContent>
    <div class="confirm-modal-sub-title" [innerHTML]="currentDescription"></div>
  </ng-container>
  <ng-template #footerTpl>
    <div class="d-flex justify-content-end">     
      <button nz-button nzType="primary" (click)="isVisibleModal=false"
        class="medium-btn small-btn width-100">
     Okay
      </button>
    </div>
  </ng-template>
</nz-modal>